module.exports = __webpack_public_path__ + "static/img/cpzxgl-DypE9E8r.646b36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/cpzxgl-DypE9E8r.png
// module id = Dtsb
// module chunks = 16